import { render, staticRenderFns } from "./HTable.vue?vue&type=template&id=bfa12084&scoped=true"
import script from "./HTable.vue?vue&type=script&lang=js"
export * from "./HTable.vue?vue&type=script&lang=js"
import style0 from "./HTable.vue?vue&type=style&index=0&id=bfa12084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa12084",
  null
  
)

export default component.exports